export enum SignupSource {
  QUICKMEMECOIN = 'quickiememecoin',
  CRYPTOBULLSVIP = 'cryptobullsvip',
  QUICKCAMCOIN = 'quickcamcoin',
  PROFILE_PAGE = 'profile-page',
  QUICKLINKS = 'quicklinks',
}
